import React from "react";
import PropTypes from 'prop-types';

import AuthorAvatar from "react-icons/lib/md/account-circle";
import SimilarAuthorsEventTypes from "data/types/SimilarAuthorsEventTypes";
import DetailViewHeader from "react/views/detailView/DetailViewHeader";
import DetailViewTitle from "react/views/detailView/DetailViewTitle";
import ScrollableText from "react/views/generic/ScrollableText";
import DetailsFooter from "react/card/DetailsFooter";
import ContentTitle from 'react/views/generic/ContentTitle';
import Icon from 'react/views/generic/Icon';
import { ReasoningLabel } from "react/views/generic/ReasoningLabel";

import "../cardDetails.less";
import "./authorDetails.less";

const AuthorDetails = props => {
	return (
		<div className="author-details">
			<div className="author-header">
				<Icon icon={AuthorAvatar} color={"rgba(0,0,0,0.5)"} />
			</div>
			<div className="details-body">
				<DetailViewHeader>
					<DetailViewTitle
						title={props.authorName}
						featureType={SimilarAuthorsEventTypes.SIMILARAUTHOR_DETAILVIEWNAME_CLICKED}
						uniqueId={props.uniqueId}
						catalogLink={props.catalogLink}
					>
						<ContentTitle>{props.authorName}</ContentTitle>
					</DetailViewTitle>
				</DetailViewHeader>
				<div className="details-reasoning">
					<ReasoningLabel featureName={"author"} />
					<ScrollableText line={12}>{props.reason}</ScrollableText>
				</div>
			</div>
			<DetailsFooter
				featureType={SimilarAuthorsEventTypes.SIMILARAUTHOR_FINDIT_CLICKED}
				uniqueId={props.uniqueId}
				catalogLink={props.catalogLink}
				linkToNovelist={props.linkToNovelist}
				pLinkFeatureType={SimilarAuthorsEventTypes.SIMILARAUTHOR_NOVELIST_CLICKED}
				pLinkDestId={props.uniqueId}
				activeTitleUi={props.activeTitleUi}
			/>
		</div>
	);
};

AuthorDetails.propTypes = {
	uniqueId: PropTypes.string.isRequired,
	activeTitleUi: PropTypes.string.isRequired,
	authorName: PropTypes.string.isRequired,
	catalogLink: PropTypes.object,
	reason: PropTypes.string,
	linkToNovelist: PropTypes.string
}

export default AuthorDetails;


// WEBPACK FOOTER //
// ./src/react/views/similarAuthors/AuthorDetails.jsx